const FormatCurrency = ({ amount, currency = "EUR" }) => {
  const formated = new Intl.NumberFormat("fr-EU", {
    style: "currency",
    currency: currency,
  }).format(amount);
  return formated;
};

export default FormatCurrency;
